import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { TextInput, Dropdown } from 'components'
import { IconSearch, IconClose } from 'components/Icons'

import type { OptionProps } from 'types'
import { convertRole } from 'features/Branch'
import type { IParamStaff } from 'features/Staff'
import { ROLE_OPTIONS, STATUS_OPTIONS } from 'helpers/constants/common'
import { useSearchParams } from 'helpers/hooks'
import { convertStatus } from 'helpers/common'

function StaffSearchAndFilter(): JSX.Element {
  const base = 'f-staff-search-and-filter'
  const [searchParams, setSearchParams] = useSearchParams<IParamStaff>({
    q: '',
  })
  const [search, setSearch] = useState<string>(searchParams.q || '')
  const { t } = useTranslation('staff')

  const role: OptionProps = convertRole(searchParams.role)
  const status: OptionProps = convertStatus(searchParams.isActive)

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    setSearch(e.target.value)
  }

  const handleSearch = () => setSearchParams({ q: search })

  const handleClearSearch = () => {
    setSearch('')
    setSearchParams({ q: '' })
  }

  const iconSearch: JSX.Element = !searchParams.q ? (
    <span className={`${base}__in-line-btn`} onClick={() => handleSearch()}>
      <IconSearch variants='sm' />
    </span>
  ) : (
    <span
      className={`${base}__in-line-btn`}
      onClick={() => handleClearSearch()}
    >
      <IconClose variants='sm' />
    </span>
  )

  return (
    <div className={base}>
      <TextInput
        placeholder={t('searchList.placeholder')}
        name='search'
        onChange={handleSearchChange}
        value={search}
        variants='secondary'
        withIcon={iconSearch}
      />
      <Dropdown
        className={`${base}__dropdown`}
        variants='secondary'
        options={ROLE_OPTIONS}
        selected={role}
        onChange={({ key }) => setSearchParams({ role: key, _page: 1 })}
        label={t('position.placeholder')}
      />
      <Dropdown
        className={`${base}__dropdown`}
        variants='secondary'
        options={STATUS_OPTIONS}
        selected={status}
        onChange={({ key }) => setSearchParams({ isActive: key, _page: 1 })}
        label={t('status.placeholder')}
      />
    </div>
  )
}

export default StaffSearchAndFilter
